import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DEFAULT_APP_BASE_URL, newAddressFor } from '@shared/app-address';
import './i18n';
import './styles/tokens.css';
import './styles/app.css';
import './styles/swipe-tabs.css';
import './styles/day-ahead.css';
import './styles/office-action.css';
import './styles/ask-sheet.css';
import './styles/reorder.css';
import './styles/press165.css';
import './styles/review165.css';
import './styles/update165.css';
import './styles/crews166.css';
import './styles/crews166-plan.css';
import './styles/crews166-order.css';
import './styles/review167.css';
import './styles/agr167.css';
import './styles/onb167.css';
import './styles/nudge167.css';
import './styles/ba167.css';
import './styles/tech168.css';
import './styles/su168.css';
import './styles/add168.css';
import './styles/card168.css';
import './styles/set169.css';
import './styles/days169.css';
import './styles/limits169.css';
import './styles/vol171.css';
import './styles/rsvp174.css';
import './styles/ep174.css';
import './styles/ev174.css';
import './styles/chart175.css';
import './styles/plate175.css';
import './styles/ep175.css';
import './styles/num175.css';
// last: what paper shows wins over every screen rule
import './styles/print175.css';
import './styles/ann176.css';
import './styles/bend178-w.css';
import './styles/bend178-t.css';
import './styles/bend178-b.css';
import './styles/draft176.css';
import './styles/cal177-m.css';
import './styles/cal177-n.css';
import './styles/cal177-e.css';
import './styles/cal177-s.css';
import './styles/cal177-v.css';
import './styles/ev179-r.css';
import './styles/ev179-m.css';
import './styles/ev179-o.css';
import './styles/ev179-a.css';
import './styles/ev179-v.css';
import './styles/ev179-f.css';
import './styles/cal182.css';
import './styles/nav184.css';
import './styles/kb184.css';
import './styles/vol182.css';
import './styles/vol1018.css';
import './styles/tenant1022.css';
import './styles/b183-t.css';
import './styles/b183-b.css';
import './styles/b183-s.css';
import './styles/b183-e.css';
import './styles/hkday1018.css';
import './styles/plan1019.css';
import './styles/nav1025.css';
import './styles/crew1102.css';
import App from './App';
import { installChunkReload } from './lib/chunk-reload';

// 1.5.13 §1c.5: a lazy chunk (script or CSS) that no longer exists after a deploy reloads the page once.
installChunkReload();

// 1.5.6: opened on the old Azure address → the same path and query on scheduler.abfselis.org, before anything paints.
const moved = newAddressFor(DEFAULT_APP_BASE_URL, window.location);
if (moved) window.location.replace(moved);
else
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
